import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

export const SectionHeading = ({ kicker, title, subtitle, center = false, dark = false }) => (
  <div className={`${center ? "mx-auto max-w-3xl text-center" : "max-w-3xl"} mb-14`}>
    {kicker && (
      <Reveal>
        <div className={`kicker mb-4 ${center ? "flex justify-center" : ""}`}>
          <span className="inline-flex items-center gap-2">
            <span className="h-px w-8 bg-orange-400/60" />
            {kicker}
          </span>
        </div>
      </Reveal>
    )}
    <Reveal i={1}>
      <h2 className={`font-head text-3xl font-bold leading-[1.1] tracking-tight sm:text-4xl lg:text-[2.75rem] ${dark ? "text-[#1C1C20]" : "text-white"}`}>
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal i={2}>
        <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-zinc-600" : "text-zinc-400"}`}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
